// COLLECTION LIST 3 Column
// $('#collection-slider').owlCarousel({
//     loop:true,
//     margin:10,
//     nav:true, 
//     responsive:{
//         0:{
//             items:1
//         },
//         1000:{
//             items:2
//         }
//     }
// })
$('.collection-slider').slick({
  dots: true,
  arrows:true,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: false,
  infinite: true
});

$('.testimonial-slider').slick({
  dots: true,
  arrows:true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  infinite: true
});



$('.brand-highlights-slider').slick({
  dots: false,
  arrows:true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  infinite: true
});



// match height JS

window.onload = function() {
  matchHeight('.abz_product_grid .product-card');
};

function matchHeight(selector) {
  // Select all elements with the specified selector
  var elements = document.querySelectorAll(selector);
  var maxHeight = 0;

  // First, find the tallest element
  elements.forEach(function(element) {
    if (element.offsetHeight > maxHeight) {
      maxHeight = element.offsetHeight;
    }
  });

  // Then, set all elements to the maxHeight
  elements.forEach(function(element) {
    element.style.height = maxHeight + 'px';
  });
}


// ASK fOR Nav slider

   $('.slider-for').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: false,
   fade: true,
   asNavFor: '.slider-nav'
 });
 $('.slider-nav').slick({
   slidesToShow: 3,
   slidesToScroll: 1,
   asNavFor: '.slider-for',
   dots: true,
   focusOnSelect: true,
   responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      }
    }
  ]
});

 $('a[data-slide]').click(function(e) {
   e.preventDefault();
   var slideno = $(this).data('slide');
   $('.slider-nav').slick('slickGoTo', slideno - 1);
 });


// slick slider with Fancybox

$('.abz_fancy_wrapper').slick({
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
         slidesToShow: 4,
      }
    },
    {
      breakpoint: 769,
      settings: {
       slidesToShow: 3,
      }
    },
    {
      breakpoint: 501,
      settings: {
       slidesToShow: 2,
      }
    }
  ]
});


$('[data-fancybox]').fancybox({
  // Options will go here
  buttons : [
    'close'
  ],
  wheel : false,
  transitionEffect: "slide",
   // thumbs          : false,
  // hash            : false,
  loop            : true,
  // keyboard        : true,
  toolbar         : false,
  // animationEffect : false,
  // arrows          : true,
  clickContent    : false
});